import { render, staticRenderFns } from "./selectMaterials.vue?vue&type=template&id=5b94fef2"
import script from "./selectMaterials.vue?vue&type=script&lang=js"
export * from "./selectMaterials.vue?vue&type=script&lang=js"
import style0 from "./selectMaterials.vue?vue&type=style&index=0&id=5b94fef2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports